// import "./validation";
import { Fancybox } from "@fancyapps/ui";
import Swiper from "swiper/bundle";
import Accordion from "accordion-js";
import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

// const menuButton = document.getElementById("menu-button");
// const menu = document.getElementById("header-menu");
// let isMenuOpen = parseInt(menuButton.dataset.isMenuOpen);
// menuButton.addEventListener("click", function () {
// 	if (isMenuOpen) {
// 		menu.classList.remove("active");
// 		isMenuOpen = !isMenuOpen;
// 	} else {
// 		menu.classList.add("active");
// 		isMenuOpen = !isMenuOpen;
// 	}
// });
function returnSwiperSettings(sectionClass) {
	return {
		slidesPerView: 1.5,
		spaceBetween: 30,
		centeredSlides: true,
		initialSlide: 1,
		// loop: true,
		breakpoints: {
			767: {
				slidesPerView: 4,
				initialSlide: 0,
				spaceBetween: 24,
				centeredSlides: false,
				loop: false,
				navigation: {
					prevEl: `${sectionClass} .slider-arrow_prev`,
					nextEl: `${sectionClass} .slider-arrow_next`,
				},
			},
		},
	};
}

function initSwiper(sectionClass) {
	let thisswiper = document.querySelector(`${sectionClass} .swiper`);
	if (thisswiper) {
		const swiper = new Swiper(
			thisswiper,
			returnSwiperSettings(sectionClass),
		);
	} else {
		console.debug("Swiper container element not found!");
	}
}

const sliders = document.querySelectorAll(".section_swiper");

sliders.forEach((element) => {
	let swiperData = element.dataset.swiper;
	if (swiperData) {
		let swiperClass = `.${element.dataset.swiper}`;
		initSwiper(swiperClass);
	}
});

let recipeGallery = document.querySelector(`.swiper_recipe`);
if (recipeGallery) {
	const swiper = new Swiper(".swiper_recipe", {
		slidesPerView: 1,
		// loop: true,
		effect: "fade",
		navigation: {
			prevEl: `.slider-arrow_prev`,
			nextEl: `.slider-arrow_next`,
		},
	});
} else {
	console.debug("Swiper container element not found!");
}

let swiperProfile = document.querySelector(`.favorites-profile`);
if (swiperProfile) {
	const swiper = new Swiper(".favorites-profile .swiper", {
		slidesPerView: 2,
		spaceBetween: 30,
		// loop: true,
		breakpoints: {
			767: {
				slidesPerView: 3,
				spaceBetween: 24,
				navigation: {
					prevEl: `.favorites-profile .slider-arrow_prev`,
					nextEl: `.favorites-profile .slider-arrow_next`,
				},
			},
		},
	});
} else {
	console.debug("Swiper container element not found!");
}

if (document.querySelector(".accordion")) {
	document.querySelectorAll(".accordion").forEach(function (element, index) {
		new Accordion(element, {
			duration: 250,
			elementClass: "ac",
			triggerClass: "ac-trigger",
			panelClass: "ac-panel",
			activeClass: "active",
			// showMultiple: true,
		});
	});
}

// Стрелка вверх
const toTopElement = document.querySelector(".to-top");
window.addEventListener(
	"scroll",
	() => {
		const isPastThreshold = window.scrollY > 500;
		toTopElement.classList.toggle("visible", isPastThreshold);
	},
	{ passive: true },
);

// должно быть везде
const menuControls = document.getElementById('menu-controls');

menuControls.addEventListener('click', (event) => {
	const instance = Fancybox.getInstance();
	if (!instance) return;

	const slide = instance.getSlide(instance.getSlide().index);

	if (slide?.src !== '#modal-nav') return;

	event.preventDefault();
	event.stopPropagation();
	instance.close();
});
Fancybox.bind("[data-fancybox]", {
	dragToClose: false,
	closeButton: false,
	autoFocus: false,
	on: {
		reveal: (fancybox, slide) => {
			if (slide.src === '#modal-nav') {
				menuControls.classList.add('active');
			}
		},
		close: () => {
			menuControls.classList.remove('active');
		},
		
		"Carousel.ready Carousel.change": function () {
			// applying Imask within Fancybox
			const that = Fancybox.getSlide().el;
			// const inputTel = that.querySelector(".input_tel:not([data-masked])");
			// if (inputTel) {
			// 	IMask(inputTel, {
			// 		mask: "+7 (000) 000-00-00",
			// 		lazy: false,
			// 	});
			// }
			const inputEmail = that.querySelector(
				".input_email:not([data-masked])",
			);
			if (inputEmail) {
				IMask(inputEmail, {
					mask: "w@e.r",
					blocks: {
						w: { mask: /^[a-zA-Z0-9._%+-]+$/ },
						e: { mask: /^[a-zA-Z0-9.-]+$/ },
						r: { mask: /^[a-zA-Z]+$/ },
					},
					// mask:
				});
			}
		},
	},
});

// Слайдер на странице видео-курсов
const swiperVideos = new Swiper(".swiper-videos .swiper", {
	slidesPerView: 1,
	allowTouchMove: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		prevEl: `.swiper-videos .pagination__link_prev`,
		nextEl: `.swiper-videos .pagination__link_next`,
	},
	pagination: {
		el: '.swiper-videos .pagination-pages',
		type: 'bullets',
		currentClass: 'active',
		bulletActiveClass: 'current',
		bulletClass: 'pagination__page'
	},
	on: {
		slideChange: function () {
			document.querySelectorAll('.js-player').forEach((videoElement, index) => {
				if (index !== this.activeIndex) {
					videoElement.pause();
					// videoElement.currentTime = 0;
				}
			});
		}
	}
});

const plyrPlayers = [];

document.querySelectorAll(".js-player").forEach((videoElement) => {
	const playerInstance = new Plyr(videoElement, {
		controls: [
			"play",
			"progress",
			"current-time",
			"mute",
			"volume",
			"fullscreen",
		],
	});
	plyrPlayers.push(playerInstance);
});


// page dots (optional but you had markup)
// const pagesContainer = document.querySelector(".pagination-pages");

// function renderPagination() {
// 	pagesContainer.innerHTML = "";

// 	plyrPlayers.forEach((_, index) => {
// 		const el = document.createElement("button");
// 		el.className =
// 			"pagination__page" +
// 			(index === swiperInstance.activeIndex ? " current" : "");
// 		el.addEventListener("click", () => swiperInstance.slideTo(index));
// 		pagesContainer.appendChild(el);
// 	});
// }

// function handleSlideChange() {
// 	const activeIndex = swiperInstance.activeIndex;

// 	plyrPlayers.forEach((playerInstance, index) => {
// 		if (index === activeIndex) return;

// 		playerInstance.pause();
// 		playerInstance.currentTime = 0;
// 	});

// 	renderPagination();
// }

// // init pagination once
// renderPagination();
